import React from 'react';
import { Link } from 'react-router-dom';

type ErrorBannerProps = {
  message: string;
  onDismiss: () => void;
  onFixBug?: () => void;
  isAdmin?: boolean;
};

export default function ErrorBanner({ message, onDismiss, onFixBug, isAdmin }: ErrorBannerProps) {
  const requestIdMatch = message.match(/\(request ([^)]+)\)/i);
  const requestId = requestIdMatch ? requestIdMatch[1] : null;
  const displayMessage = requestId ? message.replace(/\s*\(request [^)]+\)/i, '') : message;
  return (
    <div className="error error-dismissible">
      <div className="stack">
        <span>{displayMessage}</span>
        {requestId && (
          <div className="error-request">
            <div className="error-request__meta">
              <span>Request ID:</span>
              <span className="mono">{requestId}</span>
            </div>
            <div className="error-request__actions">
              <Link
                className="link-button secondary"
                to={`/logs?request_id=${encodeURIComponent(requestId)}`}
              >
                View logs
              </Link>
              {isAdmin && onFixBug && (
                <button type="button" className="link-button secondary" onClick={onFixBug}>
                  Fix bug
                </button>
              )}
            </div>
            <div className="hint">If this keeps happening, contact support with the request ID.</div>
          </div>
        )}
      </div>
      <button
        type="button"
        className="error-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss error"
      >
        ×
      </button>
    </div>
  );
}
